/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiSingleRecordFieldContainerConfig} from "./UiSingleRecordFieldContainerConfig";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiFormLayoutPolicyConfig} from "./UiFormLayoutPolicyConfig";
import {UiFieldEditingMode} from "./UiFieldEditingMode";
import {UiSingleRecordFieldContainerCommandHandler} from "./UiSingleRecordFieldContainerConfig";
import {UiSingleRecordFieldContainerEventSource} from "./UiSingleRecordFieldContainerConfig";


export interface UiGridFormConfig extends UiComponentConfig, UiSingleRecordFieldContainerConfig {
	_type?: string;
	recordTypeId: string;
	record?: any;
	fields: UiFieldConfig[];
	layoutPolicies: UiFormLayoutPolicyConfig[]
}

export interface UiGridFormCommandHandler extends UiSingleRecordFieldContainerCommandHandler {
	setRecord(record: any, updateAllFields: boolean): void;
	submit(): void;
	updateLayoutPolicies(layoutPolicies: UiFormLayoutPolicyConfig[]): void;
	setFieldEditingMode(fieldName: string, editingMode: UiFieldEditingMode): void;
	setSectionCollapsed(sectionId: string, collapsed: boolean): void;
}

export interface UiGridFormEventSource extends UiSingleRecordFieldContainerEventSource {
	onSubmitted: TeamAppsEvent<UiGridForm_SubmittedEvent>;
	onSectionCollapsedStateChanged: TeamAppsEvent<UiGridForm_SectionCollapsedStateChangedEvent>;
}

export interface UiGridForm_SubmittedEvent extends UiEvent {
	_type: "UiGridForm.submitted";
	redundancyKey?: string;
	data: any
}

export interface UiGridForm_SectionCollapsedStateChangedEvent extends UiEvent {
	_type: "UiGridForm.sectionCollapsedStateChanged";
	redundancyKey?: string;
	sectionId: string;
	collapsed: boolean
}

